import React from "react";
import { DateInputBox, TextInputBox } from "./";
import { DateQtyInputField } from "src/types";

interface DynamicDateQtyInputListProps {
  id: string;
  inputDates: DateQtyInputField[];
  onInputChange: (dates: DateQtyInputField[]) => void;
  totalQty?: string;
  maxDatesPerList?: number;
}

const DynamicDateQtyInputList: React.FC<DynamicDateQtyInputListProps> = ({
  id,
  inputDates,
  onInputChange,
  totalQty,
  maxDatesPerList = 12
}) => {
  const handleDateInputChange = (value: string, index: number, field: keyof DateQtyInputField) => {
    const updatedDates = [...inputDates];
    updatedDates[index] = { ...updatedDates[index], [field]: value };

    const isDateComplete = updatedDates[index].date.length === 10;
    const latestDate = updatedDates[updatedDates.length - 1];

    if (!isDateComplete) {
      updatedDates[index].qty = "";
      updatedDates.splice(index + 1);
      if (index === 1) {
        updatedDates[0].qty = "";
      }
    } else if (latestDate.date.length === 10 && updatedDates.length < maxDatesPerList) {
      updatedDates.push({ date: "", qty: index === 0 ? totalQty || "" : "" });
    }

    onInputChange(updatedDates);
  };

  return (
    <div className="space-y-2">
      {inputDates.map((dateObj, index) => {
        const isDateComplete = dateObj.date.length === 10;

        return (
          <div key={`expiry-date-qty-input-${index}`} className="flex items-start gap-2">
            <div className="flex-1">
              <DateInputBox
                id={`${id}-expiry-date-${index}`}
                inputDate={dateObj.date}
                onInputChange={(value) => handleDateInputChange(value, index, "date")}
              />
            </div>

            {isDateComplete && inputDates.length > 2 && (
              <div className="w-20 flex-shrink-0">
                <TextInputBox
                  id={`${id}-expiry-date-${index}-qty`}
                  value={dateObj.qty}
                  onChange={(value) => handleDateInputChange(value, index, "qty")}
                  maxLength={5}
                  placeholder="Qty"
                  size="sm"
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export { DynamicDateQtyInputList };
